module.exports = __webpack_public_path__ + "static/media/anc9ru.48ea1938.pdf";